module.exports = __webpack_public_path__ + "img/learning-forest_logo_&_colour_palette.da31cd8a.jpg";